import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

export const nfmt = (n, opts = {}) =>
    new Intl.NumberFormat('en-CA', { maximumFractionDigits: 0, ...opts }).format(n || 0);

export const cfmt = (n) =>
    new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 }).format(n || 0);

export const pfmt = (n, digits = 1) => `${(n || 0).toFixed(digits)}%`;

export const slugify = (s) =>
    (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
